import React from 'react';
import { Box, Button, Container, Grid, Paper, Stack, Typography, Alert } from '@mui/material';
import { FileDownload as DownloadIcon, BarChart as ChartIcon } from '@mui/icons-material';
import MainLayout from '../../../components/layout/MainLayout';

const ReportsPage: React.FC = () => {
  const reportTypes = [
    { title: 'Excel Export', description: 'Export all staff data to Excel format', icon: '📊' },
    { title: 'CSV Export', description: 'Export staff list in CSV format', icon: '📋' },
    { title: 'PDF Report', description: 'Generate printable PDF report', icon: '📄' },
    { title: 'Department Wise', description: 'Staff distribution by department', icon: '🏢' },
    { title: 'Designation Wise', description: 'Staff distribution by designation', icon: '👔' },
    { title: 'Attendance Report', description: 'Monthly attendance summary', icon: '📅' },
  ];

  return (
    <MainLayout>
      <Container maxWidth="lg" sx={{ py: 3 }}>
        <Stack spacing={2} sx={{ mb: 3 }}>
          <Box>
            <h2 style={{ margin: 0 }}>Reports</h2>
            <p style={{ margin: '4px 0 0 0', color: '#666', fontSize: '14px' }}>Generate and export staff reports for analysis and compliance</p>
          </Box>
        </Stack>

        <Grid container spacing={2}>
          {reportTypes.map((report) => (
            <Grid key={report.title} item xs={12} sm={6} md={4}>
              <Paper sx={{ p: 2.5, borderRadius: 2, cursor: 'pointer', '&:hover': { boxShadow: 3, transform: 'translateY(-2px)' }, transition: 'all 220ms' }}>
                <Typography variant="h5" sx={{ mb: 1 }}>{report.icon}</Typography>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 0.5 }}>{report.title}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>{report.description}</Typography>
                <Button size="small" startIcon={<DownloadIcon />}>Generate</Button>
              </Paper>
            </Grid>
          ))}
        </Grid>

        <Paper sx={{ p: 3, mt: 3 }}>
          <Alert severity="info">
            Reports are generated on-demand with real-time data. You can download them as Excel, CSV, or PDF for further analysis.
          </Alert>
        </Paper>
      </Container>
    </MainLayout>
  );
};

export default ReportsPage;
